import sessionStorageKeys from '@constants/sessionStorageKeys';

import { accessAllFavorites, accessHotelMetadataUsingHotelIds } from '@utils/services';

const updateHotelFavorites = (
  cookies: any,
  setShowCloseButton: any,
  setUserFavoritesMetadata: any,
  getItem: any,
  setUserFavoritesIds: any,
  setIsLoading: any,
  setIsRequestComplete: any,
) => {
  (async () => {
    try {
      if (cookies.userInformation?.email) {
        if (setShowCloseButton) {
          setShowCloseButton(false);
        }
        const userFav = await accessAllFavorites(cookies.userInformation);
        if (userFav !== 'error') {
          const userLocalStorageFav: any = getItem(sessionStorageKeys.USER_SESSION_FAVORITES);
          const combinedFavoritesIds = Object.keys(userFav);
          if (userLocalStorageFav && userLocalStorageFav !== 'null') {
            const { favorites } = JSON.parse(userLocalStorageFav);
            const hotelMetadata = await accessHotelMetadataUsingHotelIds(favorites);
            combinedFavoritesIds.forEach((favoriteID) => {
              if (hotelMetadata[favoriteID]) {
                delete hotelMetadata[favoriteID];
              }
            });
            setUserFavoritesIds(
              combinedFavoritesIds
                .concat(favorites)
                .filter((item, pos, self) => self.indexOf(item) === pos),
            );
            setUserFavoritesMetadata(
              Object.keys(hotelMetadata).length > 0 ? { ...userFav, ...hotelMetadata } : userFav,
            );
            if (setIsLoading) {
              setIsLoading(true);
            }
            if (setIsRequestComplete) {
              setIsRequestComplete(true);
            }
          } else {
            setUserFavoritesIds(combinedFavoritesIds);
            setUserFavoritesMetadata(userFav);
            if (setIsLoading) {
              setIsLoading(true);
            }
            if (setIsRequestComplete) {
              setIsRequestComplete(true);
            }
          }
        } else {
          setUserFavoritesIds([]);
          if (setIsLoading) {
            setIsLoading(true);
          }
          if (setIsRequestComplete) {
            setIsRequestComplete(true);
          }
        }
      } else {
        const userLocalStorageFav: any = getItem(sessionStorageKeys.USER_SESSION_FAVORITES);
        if (!userLocalStorageFav || userLocalStorageFav === 'null') {
          setUserFavoritesIds([]);
          if (setIsLoading) {
            setIsLoading(true);
          }
          if (setIsRequestComplete) {
            setIsRequestComplete(true);
          }
        } else {
          const combinedFavorites = JSON.parse(userLocalStorageFav).favorites;
          const hotelMetadata = await accessHotelMetadataUsingHotelIds(combinedFavorites);
          setUserFavoritesIds(combinedFavorites);
          setUserFavoritesMetadata(hotelMetadata);
          if (setIsLoading) {
            setIsLoading(true);
          }
          if (setIsRequestComplete) {
            setIsRequestComplete(true);
          }
        }
      }
    } catch (error) {
      // TODO: handle case for when favorites endpoint fails
    }
  })();
};

export default updateHotelFavorites;
